"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeliverySummarySkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _shared = require("../shared");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeliverySummarySkeleton = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FlatDeliveryWrapper, {
        ...getTestIdProps(_models.TestId.DeliverySummarySkeleton),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.FlatLayoutWrapper, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryHeader, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                            variant: "h6",
                            component: "div",
                            children: formatMessage('delivery')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                            variant: "text",
                            width: 80,
                            height: 30
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryContent, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryInfo, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                    fontWeight: "bold",
                                    children: formatMessage('shippingAddress')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                    variant: "text",
                                    width: "80%",
                                    height: 21
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                    variant: "text",
                                    width: "65%",
                                    height: 21
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryInfo, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                    fontWeight: "bold",
                                    children: formatMessage('deliveryMethod')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryCourierInfo, {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                            variant: "text",
                                            width: 60,
                                            height: 21
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                            variant: "text",
                                            width: 40,
                                            height: 21
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DeliverySummaryInfo, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                    fontWeight: "bold",
                                    children: formatMessage('expectedDelivery')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Skeleton, {
                                    variant: "text",
                                    width: "80%",
                                    height: 21
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
exports.DeliverySummarySkeleton = DeliverySummarySkeleton;
